import React from "react";
import { trackEvent } from "./analytics";

export default function AuthHeader({ authed, email, onLogin, onLogout }) {
  return (
    <div style={{ display: "flex", gap: 12, alignItems: "center", padding: 12 }}>
      {authed ? (
        <>
          <span>Signed in as: {email || "user"}</span>
          <button onClick={() => { trackEvent("sign_out_click"); onLogout(); }}>Sign out</button>
        </>
      ) : (
        <button
          onClick={() => {
            trackEvent("sign_in_click");
            onLogin();
          }}
        >
          Sign in
        </button>
      )}
    </div>
  );
}
